import { render, staticRenderFns } from "./DocumentViewDialog.vue?vue&type=template&id=08436ccc&"
import script from "./DocumentViewDialog.vue?vue&type=script&lang=js&"
export * from "./DocumentViewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports